var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-video-controls"},[_c('div',{staticClass:"v-video-controls-inner",style:({
      backgroundColor: _vm.themeOptions.colors.toolbar
    })},[_c('video-play',{attrs:{"videoState":_vm.videoState,"themeOptions":_vm.themeOptions}}),_c('v-spacer'),_c('video-fullscreen',{staticClass:"ml-3",attrs:{"videoState":_vm.videoState,"themeOptions":_vm.themeOptions}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }